import { getApiUrl } from '@/lib/api-config';

interface SendWarrantyEmailPayload {
  warrantyId: string;
  companyId: string;
  userId: string;
}

interface SendWarrantyEmailResponse {
  success: boolean;
  message?: string;
  error?: string;
}

// `companyId`/`userId` are kept in the payload type for signature
// compatibility with existing callers -- the backend derives both from
// the session, same as before (Document Sharing, not /api/warranties/send).
export const WarrantyEmailService = {
  async sendWarrantyEmail({ warrantyId }: SendWarrantyEmailPayload): Promise<SendWarrantyEmailResponse> {
    try {
      const response = await fetch(getApiUrl(`api/documents/warranty/${warrantyId}/share`), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      console.log('[WarrantyEmailService] Response status:', response.status);

      if (!response.ok) {
        let errorData;
        try {
          const text = await response.text();
          console.error('[WarrantyEmailService] Error response text:', text);
          errorData = JSON.parse(text);
        } catch (e) {
          errorData = { error: 'Failed to parse error response' };
        }
        console.error('[WarrantyEmailService] Error response:', errorData);
        return { success: false, error: errorData.error || errorData.message || `Failed to send warranty email (${response.status})` };
      }

      const result = await response.json();
      if (!result.emailed) {
        return { success: false, error: 'No client email found for this warranty' };
      }
      return { success: true, message: 'Warranty sent successfully' };
    } catch (error: any) {
      console.error('Error sending warranty email:', error);
      return { success: false, error: error.message || 'An unexpected error occurred' };
    }
  },
};

